import { authenticatedSessionRequestConfig } from './csrf';

export const buildTicketCreationContext = (estadiaId, clienteId) => ({
  estadia_id: estadiaId,
  cliente_id: clienteId || null,
});

export const appendCreatedTicket = (tickets, createdTicket) => [
  ...(Array.isArray(tickets) ? tickets : []),
  createdTicket,
];

export const runTicketCreationOnce = async (processingRef, operation) => {
  if (processingRef.current) return { started: false };
  processingRef.current = true;
  try {
    return { started: true, value: await operation() };
  } finally {
    processingRef.current = false;
  }
};

export const createTicketSnapshot = async ({
  apiUrl,
  tipo,
  payload,
  requestConfig,
  httpClient,
}) => {
  if (!httpClient?.post) {
    throw new Error('No se configuró el cliente HTTP para crear el ticket.');
  }
  const config = requestConfig || await authenticatedSessionRequestConfig(
    apiUrl,
    httpClient.get
  );
  const response = await httpClient.post(
    `${apiUrl}/tickets-${tipo}/`,
    payload,
    config
  );
  if (response?.status !== 201 || !response?.data?.id) {
    const error = new Error('El backend no confirmó la creación del ticket.');
    error.code = 'TICKET_NOT_CREATED';
    error.response = response;
    throw error;
  }
  return response.data;
};

export const getTicketCreationErrorMessage = (error) => {
  const status = error?.response?.status;
  const detail = String(
    error?.response?.data?.detail
    || error?.response?.data?.estadia_id?.[0]
    || error?.response?.data?.cliente_id?.[0]
    || ''
  );

  if (status === 403 && /csrf/i.test(detail)) {
    return 'La verificación de seguridad expiró. Intenta nuevamente o inicia sesión otra vez.';
  }
  if (status === 401 || status === 403) {
    return 'La sesión no está autenticada. Inicia sesión nuevamente.';
  }
  if (status === 409) {
    return detail || 'La estadía cambió y ya no permite crear este ticket.';
  }
  if (status === 400) {
    return detail || 'Los datos del ticket no son válidos.';
  }
  if (error?.code === 'CSRF_TOKEN_MISSING') {
    return 'No fue posible inicializar la verificación de seguridad. Inicia sesión nuevamente.';
  }
  if (!error?.response) {
    return 'No fue posible conectar con el servidor. Verifica la conexión e intenta nuevamente.';
  }
  return 'No fue posible crear el ticket. Intenta nuevamente.';
};
